import $ from 'jquery';
import 'slick-carousel';

let sliderRubric = {
    init() {
        sliderRubric.slider();
    },
    slider() {
        var slides = $('.block-rubrique .slide');

        $('.block-rubrique .slider').on('init', function(event, slick){
            var dots = $('.block-rubrique .slick-dots li');
            dots.each( function( k, v){
                $(this).empty().addClass( 'slide'+ k );
            });
            var items = slick.$slides;
            items.each( function( k, v){
                var text = $(this).find('.dot').html();
                $( '.block-rubrique .slide' + k ).html(text);
            });
        });


        $('.block-rubrique .slider').slick({
            dots: true,
            autoplay: false,
            autoplaySpeed: 5000,
            arrows : true,
            infinite: true,
            speed: 1000,
            fade: true,
            initialSlide: 0,
            responsive: [
                {
                  breakpoint: 700,
                  settings: {
                    fade: false,
                  }
                },
              ]
        });
    }
}

export default sliderRubric;
